import axiosSetup from "../utils/axiosSetup";
import { UnitType } from "../models/warehouseRawMaterial.model";
import { DefectiveMaterialRequest } from "../store/slices/defectiveMaterialSlice";

interface DefectiveItemPayload {
  materialId: string;
  quantity: number;
  unit: UnitType;
  remark: string;
}

// 1. Create Defective Request (BULK)
export const createDefectiveMaterialRequestApi = async (payload: {
  items: DefectiveItemPayload[];
}): Promise<DefectiveMaterialRequest[]> => {
  try {
    const res = await axiosSetup.post(
      "/warehouse/create/DefectiveMaterialRequest",
      payload
    );
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

// 2. Fetch Defective Requests
export const fetchDefectiveRequestsApi = async ({
  page = 1,
  limit = 10,
  search = "",
  storeStatus,
}: {
  page?: number;
  limit?: number;
  search?: string;
  storeStatus?: string;
}): Promise<{
  items: DefectiveMaterialRequest[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
}> => {
  try {
    const params: any = { page, limit, search };
    if (storeStatus) params.storeStatus = storeStatus;

    const res = await axiosSetup.get("/warehouse/defective-material/list", {
      params,
    });

    // Extract data handling nested pagination object
    const data = res.data.data;
    const pagination = data.pagination || {};

    return {
      items: data.items || [],
      // Check pagination object first, then fallback to root data properties
      totalItems: pagination.total || data.totalItems || data.total || 0,
      totalPages:
        pagination.totalPages || data.totalPages || data.totalLotPages || 1,
      currentPage: pagination.page || data.currentPage || data.page || 1,
    };
  } catch (error) {
    throw error;
  }
};

// 3. Review Defective Request
export const reviewDefectiveRequestApi = async (payload: {
  requestId: string;
  status: "accepted" | "rejected";
  remark?: string;
}): Promise<DefectiveMaterialRequest> => {
  try {
    const res = await axiosSetup.post(
      "/warehouse/defective-material/review",
      payload
    );
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

export const assignDefectiveResolutionApi = async (payload: {
  requestId: string;
  type: "return" | "replace" | "refund" | "shrink";
  remark?: string;
}): Promise<DefectiveMaterialRequest> => {
  try {
    const res = await axiosSetup.post(
      "/warehouse/defective-material/assign-resolution",
      payload
    );
    return res.data.data;
  } catch (error) {
    throw error;
  }
};

// Complete vendor resolution (replace or refund)
export const completeVendorResolutionApi = async (payload: {
  requestId: string;
  type: "replace" | "refund";
  quantity?: number;
  unit?: string;
  amount?: number;
  remark?: string;
}) => {
  try {
    const res = await axiosSetup.patch(
      `/warehouse/defective-requests/${payload.requestId}/complete-vendor-resolution`,
      payload
    );
    return res.data.data;
  } catch (error: any) {
    console.error("Error completing vendor resolution:", error);
    throw error.response?.data?.message || error.message;
  }
};
